<template>
  <div class="order-notice cancel-notice">
    <div class="notice-hero">
      <div class="hero-icon">
        <i class="el-icon-warning-outline" />
      </div>
      <div class="hero-title">{{ payload.title || '订舱订单被取消' }}</div>
      <div class="hero-desc">{{ payload.content || '' }}</div>
    </div>

    <div class="info-card">
      <div class="info-item">
        <div class="info-label">订单号</div>
        <div class="info-value">{{ payload.orderNo || '—' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">取消时间</div>
        <div class="info-value">{{ payload.cancelTime || '—' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">业务人</div>
        <div class="info-value">{{ payload.businessName || '—' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">航线</div>
        <div class="info-value">{{ formatScheduleInfo(payload.svcStr) }}</div>
        <div class="info-value">{{ formatRoute(payload.svcStrName) }}</div>
      </div>
    </div>
    <div class="section">
      <div class="section-label">So号</div>
      <div class="reason-box">{{ payload.soNo }}</div>
    </div>

    <div v-if="payload.cancelReason" class="section">
      <div class="section-label">取消原因</div>
      <div class="reason-box">{{ payload.cancelReason }}</div>
    </div>

    <div class="notice-actions">
      <el-button @click="$emit('later')">稍后处理</el-button>
      <el-button type="primary" @click="$emit('view-order')">查看订单</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderCancelNotice',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    /** 船期展示：船司 • MM-dd（兼容历史 "船司 - MM-dd"） */
    formatScheduleInfo(svcStr) {
      if (!svcStr) return '—'
      const text = String(svcStr).trim()
      const match = text.match(/^([A-Za-z0-9]+)\s*[-·•]\s*(\d{1,2}-\d{1,2})$/)
      if (match) {
        return `${match[1]} • ${match[2]}`
      }
      return text.replace(/\s*[-·]\s*/g, ' • ')
    },
    formatRoute(svcStr) {
      if (!svcStr) return '—'
      return String(svcStr).replace(/\s*-\s*/g, ' → ')
    }
  }
}
</script>

<style scoped>
.order-notice {
  padding: 4px 4px 0;
}
.notice-hero {
  text-align: center;
  margin-bottom: 20px;
}
.hero-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  border-radius: 14px;
  background: #fff7e8;
  color: #ff7d00;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
}
.hero-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2329;
  margin-bottom: 8px;
  line-height: 1.4;
}
.hero-desc {
  font-size: 13px;
  color: #8f959e;
  line-height: 1.6;
  padding: 0 8px;
}
.info-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 20px;
  padding: 16px 18px;
  background: #f7f8fa;
  border: 1px solid #eef0f3;
  border-radius: 10px;
}
.info-label {
  font-size: 12px;
  color: #8f959e;
  margin-bottom: 4px;
}
.info-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2329;
  word-break: break-all;
  line-height: 1.4;
}
.section {
  margin-top: 16px;
}
.section-label {
  font-size: 12px;
  color: #8f959e;
  margin-bottom: 8px;
}
.reason-box {
  padding: 12px 14px;
  border: 1px solid #e8ebf0;
  border-radius: 8px;
  background: #fafbfc;
  color: #1f2329;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}
.notice-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}
</style>
